import { useState } from "react";

import { EnumReviewSortType, SelectedTag } from "@src/api/review/types";
import { PartnerType } from "@src/define/partner";

import SortModal from "./SortModal";

import OptionSelectImg from "@src/assets/images/icon/ic-switch-vertical@3x.png";

import styles from "./reviewListOptionBox.module.scss";

const WEDDING_HALL_TAB_MENUS = [
  {
    value: null,
    text: "전체",
  },
  {
    value: "홀 투어 다녀왔어요",
    text: "웨딩홀 투어",
  },
  {
    value: "여기서 결혼했어요",
    text: "예식완료",
  },
  {
    value: "하객 리뷰",
    text: "하객",
  },
];

const ETC_PARTNER_TAB_MENUS = [
  {
    value: null,
    text: "전체",
  },
  {
    value: "상담 받았어요",
    text: "상담완료",
  },
  {
    value: "계약했어요",
    text: "계약완료",
  },
];

const SORT_MENUS = [
  {
    value: EnumReviewSortType.NEWEST,
    text: "최신순",
  },
  {
    value: EnumReviewSortType.HIGHEST,
    text: "별점 높은 순",
  },
  {
    value: EnumReviewSortType.LOWEST,
    text: "별점 낮은 순",
  },
];

export default function ReviewListOptionBox(props: {
  partnerType: number;
  filterValue: SelectedTag | null;
  onChangeFilterValue: (value: SelectedTag | null) => void;
  sortValue: EnumReviewSortType;
  onChangeSortValue: (value: EnumReviewSortType) => void;
}) {
  const [isSortModalOpen, setIsSortModalOpen] = useState(false);

  function getSortMenuText(value: EnumReviewSortType) {
    return SORT_MENUS.find((menu) => menu.value === value)?.text;
  }

  return (
    <>
      <div className={styles["review-list-option-box"]}>
        <div className={styles["tabs-box"]}>
          {props.partnerType === PartnerType.WeddingHall &&
            WEDDING_HALL_TAB_MENUS.map((menu) => (
              <button
                key={menu.value}
                className={`
                  btn ${styles["tab-button"]}
                  ${props.filterValue === menu.value ? styles["active"] : ""}
                `}
                onClick={() => props.onChangeFilterValue(menu.value as SelectedTag | null)}
              >
                {menu.text}
              </button>
            ))}
          {props.partnerType !== PartnerType.WeddingHall &&
            ETC_PARTNER_TAB_MENUS.map((menu) => (
              <button
                key={menu.value}
                className={`
                  btn ${styles["tab-button"]}
                  ${props.filterValue === menu.value ? styles["active"] : ""}
                `}
                onClick={() => props.onChangeFilterValue(menu.value as SelectedTag | null)}
              >
                {menu.text}
              </button>
            ))}
        </div>

        <div className={styles["sort-button-box"]}>
          <button
            className={`btn ${styles["sort-button"]}`}
            onClick={() => setIsSortModalOpen(true)}
          >
            <img src={OptionSelectImg} alt="" />
            <p className={styles["sort-value"]}>{getSortMenuText(props.sortValue)}</p>
          </button>
        </div>
      </div>

      <SortModal
        isOpen={isSortModalOpen}
        onClose={() => setIsSortModalOpen(false)}
        menus={SORT_MENUS}
        selectedValue={props.sortValue}
        onClickMenu={(value) => props.onChangeSortValue(value as EnumReviewSortType)}
      />
    </>
  );
}
